import { Navigate, useParams } from "react-router-dom";

/**
 * Legacy `/devices/:id` route. The canonical surface is `/devices?id=:id`
 * which opens the detail as a slide-over panel beside the list — this
 * component just redirects so existing bookmarks keep working.
 */
export function DeviceDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/devices" replace />;
  return <Navigate to={`/devices?id=${encodeURIComponent(id)}`} replace />;
}
